import { get, post } from '../../services/api.service';
import { getStore } from '../../store';

export const getconfigprices = async (configurations) => {
    const configuration = getStore().getState().configurator?.current?.configuration || {};
    const user = getStore().getState().user;
    const organization = user.identity.organization;

    const body = {
        configurations,
        organization,
    };
    
    return post("/api/configprices", body)
        .then(response => {
            if (response.error) throw new Error("404");
            return response;
        })
        .catch(error => {
            console.error("Error getting prices:", error);
            throw error; // rethrow the error for further handling
        });
};